module.exports = __webpack_public_path__ + "static/media/mongodb.fdfd8925.png";